export const CurrentPlayerSummary = ({currentPlayer, isCurrent}) => (
  <div className="bg-gray-100 rounded-xl p-3 px-4">
    <div className="text-lg font-medium">It's <span className="font-semibold text-blue-500">{isCurrent ? 'your' : `${currentPlayer.name}'s`}</span> turn.</div>
    <div className="text-sm">{isCurrent ? 'You' : 'They'} have <span className="font-semibold">{currentPlayer.remainingActions}</span> actions left in this turn,</div>
    <div className="text-sm">and {isCurrent ? 'you' : 'they'} have <span className="font-semibold">{currentPlayer.remainingTurns}</span> turns left.</div>
  </div>
)